import { HttpHeaders } from '@angular/common/http';

export const environment = {
  fdn_salt_key: "81dbb575-4df3-402c-bbb8-067df3b74418",

  is_international: false,

  production: true,

  site_URL: "https://wapi.e-md.co.za/api/site",

  fdn_URL: "https://node.e-md.co.za:3046/api/fdn/",
  google: {

    "YOUR_GTM_ID": "G-FVHVGGS5YL"

  },
  recaptcha: {
    siteKey: '6Lc2-6QrAAAAAHZjs1yVa0xKxI8WyqPAEIee0BTM',
  },


  security: {

    options: {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'x-access-token': 'a0814cce-a221-46d4-b601-34d9737e1bd8'
      })
    }
  },
};
